// extracted by mini-css-extract-plugin
module.exports = {"page":"page_page__18QVh"};